export default "__VITE_ASSET__JY2XXPL7__"